<template>
  <div class="">
    <el-card
      class="settings"
      shadow="never">
      <div
        slot="header"
        class="settings-header">商品 <el-button
          type="danger"
          style="margin-left: 8px;"
          @click="deleteitem">删除</el-button></div>
      <el-form
        ref="series"
        :rules="rules"
        :model="series"
        label-width="100px">
        <el-form-item
          label="商品排列："
          prop="layoutType">
          <el-radio-group v-model="series.layoutType">
            <el-radio-button :label="1">一行一个</el-radio-button>
            <el-radio-button :label="2">一行两个</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选择商品："
          prop="exchangeGoodsList">
          <el-button
            type="primary"
            @click="addGoods">添加</el-button>
          <el-dialog
            title="选择商品"
            append-to-body
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :visible.sync="visible1"
            width="860px">
            <div
              v-if="goodslist.length"
              class="card-list">
              <content-card
                v-for="(item,idx) in goodslist"
                :key="idx"
                :info="item"
                width="130px"
                height="130px"
                showCheckbox
                @click.native="seclectCard(item,index)" />
            </div>
            <!-- <div
              v-else
              class="empty-list">
              <i class="el-icon-edit-outline"></i>
              暂无内容，<router-link :to="{ name: 'goods'}">立即添加</router-link>
            </div> -->
            <template slot="footer">
              <el-button @click="visible1 = false">取 消</el-button>
              <el-button
                type="primary"
                @click="submitGoods">确 定</el-button>
            </template>
          </el-dialog>
          <draggable
            v-model="series.exchangeGoodsList"
            element="div"
            style="min-height:98px;"
            :options="dragOptions">
            <content-card
              v-for="(item,sindex) in series.exchangeGoodsList"
              :key="sindex"
              :info="item"
              width="120px"
              height="120px"
              :showRemark="false" />
          </draggable>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import ContentCard from '@/components/business/content-card.vue'
const MAX_LENGTH = 6
export default {
  name: 'WeSeries',
  components: { draggable, ContentCard },
  props: {
    value: {
      type: Object,
      default() {
        return {
          componentName: 'exchangeshow',
          exchangeGoodsList: [],
          layoutType: 2,
          visible: false
        }
      }
    },
    index: Number
  },
  data() {
    return {
      visible1: false, // 商品
      dragOptions: {
        animation: 0,
        disabled: false,
        group: 'description',
        ghostClass: 'ghost'
      },
      rules: {
        exchangeGoodsList: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ]
      },
      goodslist: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    series: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    seriesList: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    addGoods() {
      this.getgoodslist(() => {
        this.visible1 = true
      })
    },
    submitGoods() {
      const list = this.goodslist.filter(i => i.checked)
      this.series.exchangeGoodsList = _.cloneDeep(list)
      this.visible1 = false
    },
    getgoodslist(cb) {
      this.loading = true
      this.$store.dispatch('portal/getgoodslist', {
        payload: {
          goodsPayType: 1,
          pageNum: 1,
          pageSize: 10000,
          vendorId: this.userInfo.vendorId,
          status: 1
        },
        success: res => {
          this.loading = false
          this.goodslist = res.data.records.map(i => {
            i.title = i.goodsName
            i.remark = i.goodsDesc
            i.image = i.goodsSmallImage
            i.checked = _.findIndex(this.series.exchangeGoodsList, o => +o.exchangeGoodsId === i.exchangeGoodsId) > -1
            return i
          })
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    seclectCard(item) {
      console.log('seclectCard')
      if (!item.checked && this.series.exchangeGoodsList.length === MAX_LENGTH) {
        this.$message.error(`最多选择${MAX_LENGTH}个`)
        return
      }
      item.checked = !item.checked
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs.series.validate(v => {
          if (v) {
            resolve()
          } else {
            reject(new Error(JSON.stringify({ index: this.index })))
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.el-alert-fix {
  margin-top: 3px;
}
</style>
